import React from "react";
import { XIcon, CheckIcon } from "lucide-react";
import { CtaButton } from "./CtaButton";
import { beforeItems, afterItems } from "../data/content";
export function BeforeAfter() {
  return <section className="bg-cream px-4 py-16 sm:py-24" aria-labelledby="ba-title" data-id="element-27" data-mp="3ogavnrgxf35u">
      <div className="mx-auto max-w-5xl" data-id="element-28" data-mp="3shcysjdyrzd3">
        <h2 id="ba-title" className="mx-auto max-w-3xl text-center font-serif text-3xl font-bold leading-tight text-ink sm:text-5xl" data-id="element-29" data-mp="3sg1ri9lb89h8">
          From a student who memorizes mechanics… <em className="text-wine-700" data-id="element-30" data-mp="3jh6iyqusmnar">to a professional who thinks through cases systematically</em>
        </h2>

        <div className="mt-12 grid gap-5 md:grid-cols-2 md:gap-6" data-id="element-31" data-mp="34stltqjyyyeo">
          <div className="rounded-3xl border border-stone-300 bg-stone-100 p-6 sm:p-8" data-id="element-32" data-mp="39qlq7k1swczr">
            <div className="flex items-center gap-3" data-id="element-33" data-mp="2vr3wcq9ne9jj">
              <span className="flex h-11 w-11 items-center justify-center rounded-full bg-stone-300 text-stone-700" data-id="element-34" data-mp="2vsf2uxuh9vec">
                <XIcon className="h-6 w-6" strokeWidth={3} aria-hidden="true" data-id="element-35" data-mp="30pdvtd2enway" />
              </span>
              <h3 className="font-serif text-3xl font-bold text-stone-700" data-id="element-36" data-mp="x2qxvn975hzv">Before</h3>
            </div>
            <ul className="mt-6 space-y-4" data-id="element-37" data-mp="t51jm6rznr51">
              {beforeItems.map(item => <li key={item} className="flex gap-3 text-[17px] leading-snug text-stone-700" data-id="element-38" data-mp="171yhutafsavy">
                  <XIcon className="mt-0.5 h-5 w-5 shrink-0 text-red-600" strokeWidth={3} aria-hidden="true" data-id="element-39" data-mp="124g7cygrtnlu" />
                  {item}
                </li>)}
            </ul>
          </div>

          <div className="rounded-3xl bg-wine-800 p-6 text-white shadow-xl shadow-wine-900/20 sm:p-8" data-id="element-40" data-mp="9gsqnuimfh4h">
            <div className="flex items-center gap-3" data-id="element-41" data-mp="o5ynxcxwex9q">
              <span className="flex h-11 w-11 items-center justify-center rounded-full bg-cta text-white" data-id="element-42" data-mp="jcvpaqe9kxmo">
                <CheckIcon className="h-6 w-6" strokeWidth={3} aria-hidden="true" data-id="element-43" data-mp="3rrxei6m16xj9" />
              </span>
              <h3 className="font-serif text-3xl font-bold" data-id="element-44" data-mp="3mt2vb3k5j6ym">After — with the War Room™</h3>
            </div>
            <ul className="mt-6 space-y-4" data-id="element-45" data-mp="1qq7wzkddvdyi">
              {afterItems.map(item => <li key={item} className="flex gap-3 text-[17px] leading-snug text-wine-50" data-id="element-46" data-mp="1voj6tv3ohogq">
                  <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-green-400" strokeWidth={3} aria-hidden="true" data-id="element-47" data-mp="20hlslh27rtmd" />
                  {item}
                </li>)}
            </ul>
          </div>
        </div>

        <div className="mt-12" data-id="element-48" data-mp="17tg8mwizi8nl">
          <CtaButton label="I want to train my judgment" data-id="element-49" data-mp="1cqyh6lt3alv2" />
        </div>
      </div>
    </section>;
}